import React from 'react';
import { Landmark } from 'lucide-react';
import { TabBankImport } from './Billing';

// Standalone page for the Capitec statement import (was a Billing tab).
export default function BankImport() {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <Landmark size={22} className="text-orange-500" />
        <div>
          <h1 className="text-xl font-bold text-gray-800">Bank Import</h1>
          <p className="text-xs text-gray-400">Import a Capitec statement and match payments to invoices</p>
        </div>
      </div>
      <TabBankImport />
    </div>
  );
}
